import React from "react";
// import { useIsMobile } from "src/hooks/useIsMobile";
import { TableHeader } from "../CleaningLogsHeader/styles";
import { faCancel, IconDefinition } from "@fortawesome/pro-light-svg-icons";
import Button from "src/components/Button";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { ButtonContainer, WashroomsActionButtonContainer } from "./styles";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";

type WashroomsTableHeaderProps = {
  washroomSelectActive: boolean;
  setWashroomSelectActive: (active: boolean) => void;
  selectedCount?: number;
  onDeleteSelected?: () => void;
  isDeleting?: boolean;
  washroomCreateActive: boolean;
  setWashroomCreateActive: (active: boolean) => void;
  toggle: () => void;
};

const WashroomsTableHeader = ({
  washroomSelectActive,
  setWashroomSelectActive,
  selectedCount = 0,
  washroomCreateActive,
  setWashroomCreateActive,
  toggle,
}: WashroomsTableHeaderProps) => {
  //   const { isMobile } = useIsMobile();

  return (
    <TableHeader>
      <ButtonContainer>
        <WashroomsActionButtonContainer>
          <Button
            additionalStyles={{
              float: "unset",
              borderRadius: "10px",
              padding: "9px 20px",
              margin: "0 0 0 auto",
            }}
            icon={faPlus as IconDefinition}
            text="Create"
            onClick={() => setWashroomCreateActive(!washroomCreateActive)}
          />
          <Button
            additionalStyles={{
              float: "unset",
              borderRadius: "10px",
              padding: "9px 20px",
              margin: "0 0 0 auto",
            }}
            variant="decline"
            disabled={selectedCount === 0}
            icon={faCancel as IconDefinition}
            text="Delete"
            onClick={toggle}
          />
          <Button
            additionalStyles={{
              float: "unset",
              borderRadius: "10px",
              padding: "9px 20px",
              margin: "0 0 0 auto",
            }}
            icon={faCheck as IconDefinition}
            text={washroomSelectActive ? "Cancel" : "Select"}
            onClick={() => setWashroomSelectActive(!washroomSelectActive)}
          />
        </WashroomsActionButtonContainer>
      </ButtonContainer>
    </TableHeader>
  );
};

export default WashroomsTableHeader;
